import React, { useState, useEffect, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import './admission.css';
import { FaEllipsisV } from "react-icons/fa";
import { FaFolder } from "react-icons/fa";
import { FaTrashAlt } from "react-icons/fa";
import { FaBed } from "react-icons/fa6";
import Select from 'react-select';
import api from '../../service/caller';
import { format } from 'date-fns';
import { toast } from 'react-toastify';

function AdmissionPatientComponent({ onNext, onBack, admissions, setAdmisive, onOpenDossier }) {
  // States existants
  const [activeTab, setActiveTab] = useState('admissions');
  const [filters, setFilters] = useState({
    status: 'Active',
    hospital: '',
    searchName: ''
  });
  const [showAdmisiveModal, setAdmisiveShowModal] = useState(false);
  const [showRoomModal, setShowRoomModal] = useState(false);
  const [formData, setFormData] = useState({
    lastName: '',
    firstName: '',
    birthDate: '',
    hospitalId: '',
    departmentId: '',
    roomId: '',
    bedNumber: ''
  });
  const [roomData, setRoomData] = useState({
    roomNumber: '',
    capacity: '',
    type: '',
    pricePerDay: '',
    hospitalId: ''
  });
  const [UserData, setUserData] = useState([]);
  const [existingPatients, setExistingPatients] = useState([]);
  const [selectedPatient, setSelectedPatient] = useState(null);
  const [rooms, setRooms] = useState([]);
  const [allrooms, setAllRooms] = useState([]);
  const [availableBeds, setAvailableBeds] = useState([]);
  const [roomSelected, setRoomSelected] = useState(null);
  const [bedSelected, setBedSelected] = useState(null);
  const [dropdownOpen, setDropdownOpen] = useState({});
  const [hospitals, setHospitals] = useState([]);
  const [departments, setDepartments] = useState([]);
  const [selectedRoomForBeds, setSelectedRoomForBeds] = useState(null);
  const [bedsForRoom, setBedsForRoom] = useState([]);
  const [showBedModal, setShowBedModal] = useState(false);
  const [bedData, setBedData] = useState({
    bedNumber: '',
    description: '',
    isOccupied: false,
    roomId: ''
  });

  // États de pagination
  const [currentPageAdmissions, setCurrentPageAdmissions] = useState(1);
  const [itemsPerPageAdmissions, setItemsPerPageAdmissions] = useState(10);
  const [currentPageRooms, setCurrentPageRooms] = useState(1);
  const [itemsPerPageRooms, setItemsPerPageRooms] = useState(10);
  const [roomTabFilter, setRoomTabFilter] = useState('');

  // Calcul des admissions filtrées (existant)
  const filteredAdmissions = useMemo(() => {
    return admissions.filter(adm => {
      if (filters.status && adm.status !== filters.status) return false;
      if (filters.hospital && adm.hospitalId._id !== filters.hospital) return false;
      if (filters.searchName) {
        const searchLower = filters.searchName.toLowerCase();
        const fullName = `${adm.patientId.lastname} ${adm.patientId.firstname}`.toLowerCase();
        if (!fullName.includes(searchLower)) return false;
      }
      return true;
    });
  }, [admissions, filters]);

  // Calcul des admissions paginées
  const paginatedAdmissions = useMemo(() => {
    const startIndex = (currentPageAdmissions - 1) * itemsPerPageAdmissions;
    return filteredAdmissions.slice(startIndex, startIndex + itemsPerPageAdmissions);
  }, [filteredAdmissions, currentPageAdmissions, itemsPerPageAdmissions]);

  // Calcul des chambres paginées
  const filteredRooms = useMemo(() => {
    if (!roomTabFilter) return allrooms;
    return allrooms.filter(room => room.hospitalId === roomTabFilter);
  }, [allrooms, roomTabFilter]);
  
  const paginatedRooms = useMemo(() => {
    const startIndex = (currentPageRooms - 1) * itemsPerPageRooms;
    return filteredRooms.slice(startIndex, startIndex + itemsPerPageRooms);
  }, [filteredRooms, currentPageRooms, itemsPerPageRooms]);
  useEffect(() => {
    setCurrentPageRooms(1);
  }, [roomTabFilter]);

  // Reset de la pagination quand les données changent
  useEffect(() => {
    if (filteredAdmissions.length > 0 && 
        currentPageAdmissions > Math.ceil(filteredAdmissions.length / itemsPerPageAdmissions)) {
      setCurrentPageAdmissions(1);
    }
  }, [filteredAdmissions, itemsPerPageAdmissions]);

  useEffect(() => {
    if (allrooms.length > 0 && 
        currentPageRooms > Math.ceil(allrooms.length / itemsPerPageRooms)) {
      setCurrentPageRooms(1);
    }
  }, [allrooms, itemsPerPageRooms]);

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilters(prev => ({ ...prev, [name]: value }));
  };

  // Récupérer l'ID utilisateur du token
  const getUserIdFromToken = () => {
    const token = localStorage.getItem('access_token');
    if (token) {
      const decodedToken = JSON.parse(atob(token.split('.')[1]));
      return decodedToken.userId;
    }
    return null;
  };

  const userId = getUserIdFromToken();

  // Charger les données utilisateur
  useEffect(() => {
    const fetchLoggedUserData = async () => {
      try {
        const response = await api.get('api/usersprofile');
        setUserData(response.data);
      } catch (error) {
        console.error("Failed to fetch user data", error);
      }
    };

    fetchLoggedUserData();
  }, []);

  // Charger les hôpitaux
  useEffect(() => {
    const fetchHospitals = async () => {
      if (!userId) return;

      try {
        const response = await api.get(`/api/hospitals/admin/${userId}`, {
          headers: {
            'Authorization': `Bearer ${localStorage.getItem('token')}`
          }
        });

        if (response.status === 200) {
          setHospitals(response.data);
        }
      } catch (error) {
        console.error('Erreur lors de la récupération des hôpitaux:', error);
      }
    };

    if (userId) {
      fetchHospitals();
    }
  }, [userId]);

  // Charger les patients, chambres et admissions
  useEffect(() => {
    const fetchPatients = async () => {
      const hospitalIds = UserData.hospital_id;
      try {
        const response = await api.get(`/clinic/patients`, {
          params: { hospitalIds }
        });
        
        // Récupérer les IDs des patients déjà admis (statut "Active")
        const admittedIds = admissions
          .filter(adm => adm.status === "Active")
          .map(adm => adm.patientId._id);

        console.log("Unfilter", admittedIds)
        
        // Filtrer les patients pour exclure les admis actifs
        const filteredPatients = response.data.patients.filter(
          patient => !admittedIds.includes(patient._id)
        );
        console.log("filter", filteredPatients)
  
        // Créer les options pour le Select
        const patientOptions = filteredPatients.map(patient => ({
          value: patient._id,
          label: `${patient.lastname} ${patient.firstname}`,
          patient: patient
        }));
        
        setExistingPatients(patientOptions);
      } catch (error) {
        console.error("Erreur lors du chargement des patients:", error);
      }
    };

    const fetchRooms = async () => {
      try {
        if (formData.hospitalId) {
          const response = await api.get(`/api/rooms/getrooms/${formData.hospitalId}`);
          setRooms(response.data);
        }
        let allRooms = [];

        // Étape 2 : récupérer les chambres pour chaque hôpital
        for (const hospital of hospitals) {
          const roomsResponse = await api.get(`/api/rooms/getrooms/${hospital._id}`); // ou hospital.id selon ton modèle
          allRooms = allRooms.concat(roomsResponse.data);
        }

        // Étape 3 : stocker toutes les chambres
        setAllRooms(allRooms);
      } catch (error) {
        console.error('Erreur lors du chargement des chambres de tous les hôpitaux:', error);
      }
    };

    const fetchAdmissions = async () => {
      try {
        const response = await api.get(`/api/rooms/admissions`);
        setAdmisive(response.data);
      } catch (error) {
        console.error('Erreur lors du chargement des admissions:', error);
      }
    };

    const fetchDepartments = async () => {
      try {
        console.log("select", formData.hospitalId)
        const hospitalId = formData.hospitalId; // Utiliser l'ID de l'hôpital principal
        const response = await api.get(`/api/departments/hospital/${hospitalId}`, {
          headers: {
            'Authorization': `Bearer ${localStorage.getItem('access_token')}`,
          }
        });

        // Mettre à jour les départements dans l'état
        setDepartments(response.data.data);
      } catch (error) {
        console.error('Erreur lors de la récupération des départements:', error);
      }
    };

    fetchAdmissions();
    fetchRooms();
    fetchPatients();
    fetchDepartments();
  }, [UserData.hospital_id, formData.hospitalId]);

  const handleDeleteRoom = async (roomId) => {
    if (window.confirm("Êtes-vous sûr de vouloir supprimer cette chambre ? Cette action est irréversible.")) {
      try {
        const response = await api.delete(`/api/rooms/delete/${roomId}`);

        if (response.status === 200) {
          toast.success('Chambre supprimée avec succès');

          // Si la chambre supprimée était celle affichée, réinitialiser l'affichage des lits
          if (selectedRoomForBeds && selectedRoomForBeds._id === roomId) {
            setSelectedRoomForBeds(null);
            setBedsForRoom([]);
          }

          // Rafraîchir la liste des chambres
          let allRooms = [];
          for (const hospital of hospitals) {
            const roomsResponse = await api.get(`/api/rooms/getrooms/${hospital._id}`);
            allRooms = allRooms.concat(roomsResponse.data);
          }
          setAllRooms(allRooms);
        }
      } catch (error) {
        console.error('Erreur lors de la suppression de la chambre:', error);
        toast.error('Une erreur est survenue lors de la suppression de la chambre');
      }
    }
  };

  // Fonction pour supprimer un lit
  const handleDeleteBed = async (roomId, bedNumber) => {
    if (window.confirm(`Êtes-vous sûr de vouloir supprimer le lit n°${bedNumber} ? Cette action est irréversible.`)) {
      try {
        const response = await api.put(`/api/rooms/removebed/${roomId}`, { bedNumber });

        if (response.status === 200) {
          toast.success('Lit supprimé avec succès');

          // Rafraîchir la liste des lits
          fetchBedsForRoom(roomId);

          // Rafraîchir la liste des chambres
          let allRooms = [];
          for (const hospital of hospitals) {
            const roomsResponse = await api.get(`/api/rooms/getrooms/${hospital._id}`);
            allRooms = allRooms.concat(roomsResponse.data);
          }
          setAllRooms(allRooms);
        }
      } catch (error) {
        console.error('Erreur lors de la suppression du lit:', error);
        toast.error('Une erreur est survenue lors de la suppression du lit');
      }
    }
  };
  // Récupérer les lits disponibles pour une chambre spécifique
  const fetchAvailableBeds = async (roomId) => {
    try {
      const roomsFiltered = rooms.filter(room => room._id === roomId);
      if (roomsFiltered.length > 0) {
        setAvailableBeds(roomsFiltered[0].beds);
      }
    } catch (error) {
      console.error('Erreur lors du chargement des lits disponibles:', error);
      setAvailableBeds([]);
    }
  };

  // Récupérer tous les lits d'une chambre pour l'affichage détaillé
  const fetchBedsForRoom = async (roomId) => {
    try {
      const roomsFiltered = allrooms.filter(room => room._id === roomId);
      if (roomsFiltered.length > 0) {
        setBedsForRoom(roomsFiltered[0].beds);
        setSelectedRoomForBeds(roomsFiltered[0]);
        setBedData({ ...bedData, roomId: roomId });
      }
    } catch (error) {
      console.error('Erreur lors du chargement des lits:', error);
      setBedsForRoom([]);
    }
  };

  // Handlers pour les formulaires
  const handleChange = (e) => {
    if (e && e.target === undefined) {
      setFormData(prev => ({ ...prev, [e.name]: e.value }));
    } else {
      const { name, value } = e.target;
      setFormData(prev => ({ ...prev, [name]: value }));
    }
  };

  const handleRoomChange = (e) => {
    if (e && e.target === undefined) {
      setRoomData(prev => ({ ...prev, [e.name]: e.value }));
    } else {
      const { name, value } = e.target;
      setRoomData(prev => ({ ...prev, [name]: value }));
    }
  };

  const handleBedChange = (e) => {
    const { name, value, type, checked } = e.target;
    const val = type === 'checkbox' ? checked : value;
    setBedData(prev => ({ ...prev, [name]: val }));
  };

  const handlePatientSelect = (option) => {
    setSelectedPatient(option);
    if (option) {
      const patient = option.patient;
      setFormData({
        ...formData,
        lastName: patient.lastname || '',
        firstName: patient.firstname || '',
        birthDate: format(new Date(patient.age), "yyyy-MM-dd") || '',
      });
    }
  };

  // Handler pour les actions sur les icônes dans le tableau
  const toggleDropdown = idx => {
    setDropdownOpen(prev => ({ ...prev, [idx]: !prev[idx] }));
  };

  const handleBedClick = (idx) => {
    setAdmisive(prev => {
      const updated = [...prev];
      updated[idx].bedClicked = !updated[idx].bedClicked;
      return updated;
    });
    onNext(2);
  };

  const handleFolderClick = (idx) => {
    setAdmisive(prev => {
      const updated = [...prev];
      updated[idx].folderClicked = !updated[idx].folderClicked;
      onOpenDossier(updated[idx]);
      return updated;
    });
  };

  // Soumission des formulaires
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const admissionData = {
        ...formData,
        patientId: selectedPatient ? selectedPatient?.patient?._id : null
      };

      const response = await api.put('/api/rooms/assignpatient', admissionData);

      if (response.status === 201 || response.status === 200) {
        setAdmisiveShowModal(false);
        setFormData({
          lastName: '',
          firstName: '',
          birthDate: '',
          hospitalId: '',
          departmentId: '',
          roomId: '',
          bedNumber: ''
        })
        setSelectedPatient(null)
        setRoomSelected(null)
        setBedSelected(null)
        
        // Rafraîchir la liste des admissions
        const admissionsResponse = await api.get(`/api/rooms/admissions`);
        setAdmisive(admissionsResponse.data);
        toast.success("Admission validée avec succès");
      }
    } catch (error) {
      console.error('Erreur lors de l\'enregistrement de l\'admission:', error);
      toast.error('Une erreur est survenue lors de l\'enregistrement');
    }
  };

  const handleRoomSubmit = async (e) => {
    e.preventDefault();

    try {
      const response = await api.post('/api/rooms/createrooms', roomData);

      if (response.status === 201 || response.status === 200) {
        toast.success('Chambre ajoutée avec succès!');

        setRoomData({
          hospitalId: '',
          roomNumber: '',
          type: '',
          capacity: '',
          pricePerDay: ''
        });

        setShowRoomModal(false);

        // Rafraîchir la liste des chambres
        let allRooms = [];

        // Étape 2 : récupérer les chambres pour chaque hôpital
        for (const hospital of hospitals) {
          const roomsResponse = await api.get(`/api/rooms/getrooms/${hospital._id}`); // ou hospital.id selon ton modèle
          allRooms = allRooms.concat(roomsResponse.data);
        }

        // Étape 3 : stocker toutes les chambres
        setRooms(allRooms);
      }
    } catch (error) {
      console.error('Error creating room:', error);

      if (error.response) {
        toast.error(`Erreur: ${error.response.data.message || 'Une erreur est survenue lors de la création de la chambre'}`);
      } else if (error.request) {
        toast.error('Erreur de connexion. Veuillez vérifier votre connexion internet.');
      } else {
        toast.error('Erreur: ' + error.message);
      }
    }
  };

  const handleBedSubmit = async (e) => {
    e.preventDefault();

    try {
      // API call pour ajouter un lit dans une chambre existante
      const response = await api.put(`/api/rooms/addbed/${bedData.roomId}`, {
        bedNumber: bedData.bedNumber
      });

      if (response.status === 201 || response.status === 200) {
        toast.success('Lit ajouté avec succès!');

        setBedData({
          bedNumber: '',
          description: '',
          isOccupied: false,
          roomId: selectedRoomForBeds?._id || ''
        });

        setShowBedModal(false);

        // Rafraîchir la liste des lits
        fetchBedsForRoom(selectedRoomForBeds?._id);

        // Rafraîchir la liste des chambres
        let allRooms = [];

        // Étape 2 : récupérer les chambres pour chaque hôpital
        for (const hospital of hospitals) {
          const roomsResponse = await api.get(`/api/rooms/getrooms/${hospital._id}`); // ou hospital.id selon ton modèle
          allRooms = allRooms.concat(roomsResponse.data);
        }

        // Étape 3 : stocker toutes les chambres
        setAllRooms(allRooms);
      }
    } catch (error) {
      console.error('Error adding bed:', error);
      toast.error('Une erreur est survenue lors de l\'ajout du lit');
    }
  };

  // Options pour les selects
  const roomTypeOptions = [
    { value: "General", label: "General", name: 'type' },
    { value: "Private", label: "Private", name: 'type' },
    { value: "ICU", label: "ICU", name: 'type' }
  ];

  // Styles pour react-select
  const customStyles = {
    control: (base) => ({
      ...base,
      minHeight: '38px',
      borderRadius: '4px',
      borderColor: '#ced4da',
      boxShadow: 'none',
      '&:hover': {
        borderColor: '#80bdff'
      }
    }),
    placeholder: (base) => ({
      ...base,
      color: '#6c757d'
    }),
    option: (base, state) => ({
      ...base,
      backgroundColor: state.isFocused ? '#f8f9fa' : 'white',
      color: '#495057',
      '&:active': {
        backgroundColor: '#e9ecef'
      }
    })
  };

  const customSelectStyles = {
    control: (base) => ({
      ...base,
      minHeight: '40px',
      width: '100%'
    })
  };

  return (  
    <div className="ptrm-frame">
      <h1 className="ptrm-header">Gestion des Patients et Chambres</h1>
      
      {/* Tabs Navigation */}
      <div className="ptrm-tabs-container">
        <div 
          className={`ptrm-tab ${activeTab === 'admissions' ? 'active' : ''}`} 
          onClick={() => setActiveTab('admissions')}
        >
          Admissions
        </div>
        <div 
          className={`ptrm-tab ${activeTab === 'rooms' ? 'active' : ''}`} 
          onClick={() => setActiveTab('rooms')}
        >
          Chambres et Lits
        </div>
      </div>

      {/* Tab Content: Admissions */}
      {activeTab === 'admissions' && (
        <div className="ptrm-tab-content">
          <div className='ptrm-action-bar'>
            <button className="ptrm-add-admission-btn" onClick={() => setAdmisiveShowModal(true)}>
              + Nouvelle Admission
            </button>
          </div>
          
          <div className="ptrm-card">
            <div className="ptrm-filters-container">
              <div className="ptrm-filter-item">
                <input 
                  type="text" 
                  name="searchName" 
                  placeholder="Rechercher par nom..." 
                  value={filters.searchName} 
                  onChange={handleFilterChange} 
                  className="ptrm-filter-input" 
                />
              </div>
              <div className="ptrm-filter-item">
                <select 
                  name="status" 
                  value={filters.status} 
                  onChange={handleFilterChange} 
                  className="ptrm-filter-select"
                >
                  <option value="">Tous les statuts</option>
                  <option value="Active">Active</option>
                  <option value="Discharged">Discharged</option>
                </select>
              </div>
              <div className="ptrm-filter-item">
                <select 
                  name="hospital" 
                  value={filters.hospital} 
                  onChange={handleFilterChange} 
                  className="ptrm-filter-select"
                >
                  <option value="">Tous les hôpitaux</option>
                  {hospitals.map(hospital => (
                    <option key={hospital._id} value={hospital._id}>
                      {hospital.hospital_name}
                    </option>
                  ))}
                </select>
              </div>
            </div>

            <div className="ptrm-table-responsive">
              <table className="ptrm-table">
                <thead>
                  <tr>
                    <th>ID Admission</th>
                    <th>Nom</th>
                    <th>Prénom</th>
                    <th>Hospital</th>
                    <th>Horodatage</th>
                    <th>Status</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                {paginatedAdmissions.length > 0 ? (
                    paginatedAdmissions.map((adm, idx) => (
                      <tr key={idx}>
                        <td data-label="ID">{adm._id}</td>
                        <td data-label="Nom">{adm.patientId.lastname}</td>
                        <td data-label="Prénom">{adm.patientId.firstname}</td>
                        <td data-label="Hospital">{adm.hospitalId.hospital_name}</td>
                        <td data-label="Date">{format(new Date(adm.admissionDate), 'yyyy-MM-dd HH:mm')}</td>
                        <td data-label="Status">{adm.status}</td>
                        <td data-label="Actions" className='ptrm-actions-cell'>
                          {adm.status === "Active" && (
                            <button
                              className={`ptrm-btn-icon ptrm-bed-icon ${adm.bedClicked ? 'clicked' : 'not-clicked'}`}
                              onClick={() => { onOpenDossier(adm); onNext(2); }}
                              disabled={adm.status !== "Active"}
                              title="Attribuer un lit"
                            >
                              <span role="img" aria-label="lit"><FaBed size={20} /></span>
                            </button>
                          )}
                          <button
                            className={`ptrm-btn-icon ptrm-folder-icon ${adm.folderClicked ? 'clicked' : 'not-clicked'}`}
                            onClick={() => onOpenDossier(adm)}
                            title="Dossier patient"
                          >
                            <span aria-label="folder"><FaFolder size={20} /></span>
                          </button>
                          <div className="ptrm-options-wrapper">
                            <button
                              type="button"
                              className="ptrm-options-button"
                              onClick={() => toggleDropdown(idx)}
                              title="Options"
                            >
                              <FaEllipsisV size={20} aria-label="options" />
                            </button>
                            {dropdownOpen[idx] && (
                              <ul className="ptrm-options-menu">
                                <li className="ptrm-options-menu-item" onClick={() => { onOpenDossier(adm); onNext(3); }}>
                                  Treatment plan
                                </li>
                                <li className="ptrm-options-menu-item" onClick={() => { onOpenDossier(adm); onNext(4); }}>
                                  Daily monitoring
                                </li>
                                <li className="ptrm-options-menu-item" onClick={() => { onOpenDossier(adm); onNext(5); }}>
                                  Monitorings
                                </li>
                                <li className="ptrm-options-menu-item" onClick={() => { onOpenDossier(adm); onNext(6); }}>
                                  Facturation
                                </li>
                                <li className="ptrm-options-menu-item" onClick={() => { onOpenDossier(adm); onNext(7); }}>
                                  Decharge
                                </li>
                                {adm.status !== "Active" && (<li className="ptrm-options-menu-item" onClick={() => { onOpenDossier(adm); onNext(9); }}>
                                  Instruction
                                </li>)}
                              </ul>
                            )}
                          </div>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="7" style={{ textAlign: 'center' }}>Aucun patient admis</td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
                        {/* Pagination pour les admissions */}
                        {filteredAdmissions.length > itemsPerPageAdmissions && (
              <div className="ptrm-pagination">
                <button 
                  className="ptrm-pagination-btn"
                  onClick={() => setCurrentPageAdmissions(p => Math.max(p - 1, 1))}
                  disabled={currentPageAdmissions === 1}
                >
                  Précédent
                </button>
                <span className="ptrm-pagination-info">
                  Page {currentPageAdmissions} sur {Math.ceil(filteredAdmissions.length / itemsPerPageAdmissions)}
                </span>
                <button 
                  className="ptrm-pagination-btn"
                  onClick={() => setCurrentPageAdmissions(p => Math.min(
                    p + 1, 
                    Math.ceil(filteredAdmissions.length / itemsPerPageAdmissions)
                  ))}
                  disabled={currentPageAdmissions === Math.ceil(filteredAdmissions.length / itemsPerPageAdmissions)}
                >
                  Suivant
                </button>
              </div>
            )}
          </div>
        </div>
      )}

      {/* Tab Content: Rooms and Beds */}
      {activeTab === 'rooms' && (
        <div className="ptrm-tab-content">
          <div className='ptrm-action-bar'>
            <button className="ptrm-add-room-btn" onClick={() => setShowRoomModal(true)}>
              + Ajouter une Chambre
            </button>
          </div>
          <div className="ptrm-filter-item">
            <label htmlFor="room-hospital-filter">Filtrer par hôpital</label>
            <select 
              id="room-hospital-filter"
              value={roomTabFilter} 
              onChange={(e) => setRoomTabFilter(e.target.value)}
              className="ptrm-filter-select"
            >
              <option value="">Tous les hôpitaux</option>
              {hospitals.map(hospital => (
                <option key={hospital._id} value={hospital._id}>
                  {hospital.hospital_name}
                </option>
              ))}
            </select>
          </div>
          
          <div className="ptrm-card">
            <div className="ptrm-rooms-container">
              <div className="ptrm-rooms-list">
                <div className="ptrm-table-responsive">
                  <table className="ptrm-table">
                    <thead>
                      <tr>
                        <th>Chambre</th>
                        <th>Type</th>
                        <th>Capacité</th>
                        <th>Prix/Jour</th>
                        <th>Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                    {paginatedRooms.length > 0 ? (
                        paginatedRooms.map((room, idx) => (
                          <tr 
                            key={idx} 
                            className={selectedRoomForBeds?._id === room._id ? 'ptrm-selected-room' : ''}
                          >
                            <td data-label="Chambre">{room.roomNumber}</td>
                            <td data-label="Type">{room.type}</td>
                            <td data-label="Capacité">{room.capacity}</td>
                            <td data-label="Prix/Jour">{room.pricePerDay}</td>
                            <td data-label="Actions">
                              <div className="ptrm-action-buttons">
                                <button
                                  className="ptrm-view-beds-btn"
                                  onClick={() => fetchBedsForRoom(room._id)}
                                >
                                  Voir les lits
                                </button>
                                <button
                                  className="ptrm-delete-btn"
                                  onClick={() => handleDeleteRoom(room._id)}
                                  title="Supprimer la chambre"
                                >
                                  <FaTrashAlt />
                                </button>
                              </div>
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="5" style={{ textAlign: 'center' }}>Aucune chambre disponible</td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
                {/* Pagination pour les chambres */}
                {allrooms.length > itemsPerPageRooms && (
                  <div className="ptrm-pagination">
                    <button 
                      className="ptrm-pagination-btn"
                      onClick={() => setCurrentPageRooms(p => Math.max(p - 1, 1))}
                      disabled={currentPageRooms === 1}
                    >
                      Précédent
                    </button>
                    <span className="ptrm-pagination-info">
                      Page {currentPageRooms} sur {Math.ceil(allrooms.length / itemsPerPageRooms)}
                    </span>
                    <button 
                      className="ptrm-pagination-btn"
                      onClick={() => setCurrentPageRooms(p => Math.min(
                        p + 1, 
                        Math.ceil(allrooms.length / itemsPerPageRooms)
                      ))}
                      disabled={currentPageRooms === Math.ceil(allrooms.length / itemsPerPageRooms)}
                    >
                      Suivant
                    </button>
                  </div>
                )}
              </div>
              
              {selectedRoomForBeds && (
                <div className="ptrm-beds-list">
                  <h5 className="ptrm-beds-title">Lits de la chambre {selectedRoomForBeds.roomNumber}</h5>
                  <button className="ptrm-add-bed-btn" onClick={() => setShowBedModal(true)}>
                    + Ajouter un Lit
                  </button>
                  <div className="ptrm-table-responsive">
                    <table className="ptrm-table">
                      <thead>
                        <tr>
                          <th>Numéro</th>
                          <th>Description</th>
                          <th>Statut</th>
                          <th>Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {bedsForRoom.length > 0 ? (
                          bedsForRoom.map((bed, idx) => (
                            <tr key={idx}>
                              <td data-label="Numéro">{bed.bedNumber}</td>
                              <td data-label="Description">{bed.description || 'N/A'}</td>
                              <td data-label="Statut">{bed.isOccupied ? 'Occupé' : 'Disponible'}</td>
                              <td data-label="Actions">
                                <button
                                  className="ptrm-delete-btn"
                                  onClick={() => handleDeleteBed(selectedRoomForBeds._id, bed.bedNumber)}
                                  title="Supprimer le lit"
                                  disabled={bed.isOccupied}
                                >
                                  <FaTrashAlt />
                                </button>
                              </td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td colSpan="4" style={{ textAlign: 'center' }}>Aucun lit dans cette chambre</td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      )}

      {/* Modal: Nouvelle Admission */}
      {showAdmisiveModal && (
        <div className="ptrm-modal-overlay">
          <div className="ptrm-modal-content">
            <h2 className="ptrm-modal-header">Nouvelle Admission</h2>
            <form onSubmit={handleSubmit} className="ptrm-form">
              <div className="ptrm-form-row">
                <div className="ptrm-form-group ptrm-full-width">
                  <label className='ptrm-label'>Sélectionner un patient existant</label>
                  <Select
                    options={existingPatients}
                    value={selectedPatient}
                    onChange={handlePatientSelect}
                    placeholder="Rechercher un patient..."
                    isClearable
                    styles={customSelectStyles}
                    className="ptrm-select-container"
                  />
                </div>
              </div>
              <div className="ptrm-form-row">
                <div className="ptrm-form-group ptrm-full-width">
                  <label className='ptrm-label'>Hôpital</label>
                  <Select
                    options={hospitals.map(hospital => ({
                      value: hospital._id,
                      label: hospital.hospital_name,
                      name: 'hospitalId'
                    }))}
                    value={hospitals.find(h => h._id === formData.hospitalId) ?
                      {
                        value: hospitals.find(h => h._id === formData.hospitalId)._id,
                        label: hospitals.find(h => h._id === formData.hospitalId).hospital_name
                      } : null}
                    onChange={handleChange}
                    placeholder="Sélectionner un hôpital"
                    styles={customStyles}
                    isSearchable
                    className="ptrm-select-container"
                  />
                </div>
              </div>
              <div className="ptrm-form-row">
                <div className="ptrm-form-group ptrm-full-width">
                  <label className='ptrm-label'>Department</label>
                  <Select
                    options={departments.map(dept => ({
                      value: dept._id,
                      label: dept.name,
                      name: 'departmentId'
                    }))}
                    value={departments.find(d => d._id === formData.departmentId) ?
                      {
                        value: departments.find(d => d._id === formData.departmentId)._id,
                        label: departments.find(d => d._id === formData.departmentId).name
                      } : null}
                    onChange={handleChange}
                    placeholder="Sélectionner un département"
                    styles={customStyles}
                    isSearchable
                    className="ptrm-select-container"
                  />
                </div>
              </div>
              <div className="ptrm-form-row">
                <div className="ptrm-form-group">
                  <label className='ptrm-label'>Chambre</label>
                  <Select
                    options={rooms.map(room => ({
                      value: room._id,
                      label: `${room.roomNumber} - ${room.type} (${room.pricePerDay})`
                    }))}
                    value={roomSelected}
                    onChange={(option) => {
                      setRoomSelected(option);
                      setFormData(prev => ({ ...prev, roomId: option ? option.value : '' }));
                      if (option) {
                        fetchAvailableBeds(option.value);
                      } else {
                        setAvailableBeds([]);
                        setBedSelected(null);
                        setFormData(prev => ({ ...prev, bedId: '' }));
                      }
                    }}
                    placeholder="Sélectionner une chambre..."
                    isClearable
                    styles={customSelectStyles}
                    className="ptrm-select-container"
                  />
                </div>
                <div className="ptrm-form-group">
                  <label className='ptrm-label'>Lit</label>
                  <Select
                    options={availableBeds.filter(bed => !bed.isOccupied).map(bed => ({
                      value: bed.bedNumber,
                      label: `Lit ${bed.bedNumber}${bed.description ? ` - ${bed.description}` : ''}`
                    }))}
                    value={bedSelected}
                    onChange={(option) => {
                      setBedSelected(option);
                      setFormData(prev => ({ ...prev, bedNumber: option ? option.value : '' }));
                    }}
                    placeholder="Sélectionner un lit..."
                    isClearable
                    isDisabled={!roomSelected}
                    styles={customSelectStyles}
                    className="ptrm-select-container"
                  />
                </div>
              </div>
              <div className="ptrm-form-actions">
                <button type="submit" className="ptrm-btn-save">
                  Valider l'admission
                </button>
                <button
                  type="button"
                  className="ptrm-btn-cancel"
                  onClick={() => setAdmisiveShowModal(false)}
                >
                  Annuler
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* Modal: Nouvelle Chambre */}
      {showRoomModal && (
        <div className="ptrm-modal-overlay">
          <div className="ptrm-modal-content">
            <h2 className="ptrm-modal-header">Nouvelle Chambre</h2>
            <form onSubmit={handleRoomSubmit} className="ptrm-form">
              <div className="ptrm-form-row">
                <div className="ptrm-form-group ptrm-full-width">
                  <label className='ptrm-label'>Hôpital</label>
                  <Select
                    options={hospitals.map(hospital => ({
                      value: hospital._id,
                      label: hospital.hospital_name,
                      name: 'hospitalId'
                    }))}
                    value={hospitals.find(h => h._id === roomData.hospitalId) ?
                      {
                        value: hospitals.find(h => h._id === roomData.hospitalId)._id,
                        label: hospitals.find(h => h._id === roomData.hospitalId).hospital_name
                      } : null}
                    onChange={handleRoomChange}
                    placeholder="Sélectionner un hôpital"
                    styles={customStyles}
                    isSearchable
                    className="ptrm-select-container"
                  />
                </div>
              </div>
              <div className="ptrm-form-row">
                <div className="ptrm-form-group ptrm-full-width">
                  <label htmlFor="roomNumber" className='ptrm-label'>Nom de la chambre</label>
                  <input
                    id="roomNumber"
                    name="roomNumber"
                    type="text"
                    value={roomData.roomNumber}
                    onChange={handleRoomChange}
                    required
                    className="ptrm-input"
                  />
                </div>
              </div>
              <div className="ptrm-form-row">
                <div className="ptrm-form-group ptrm-full-width">
                  <label className='ptrm-label'>Type de chambre</label>
                  <Select
                    options={roomTypeOptions}
                    value={roomTypeOptions.find(option => option.value === roomData.type)}
                    onChange={handleRoomChange}
                    placeholder="Type de chambre"
                    styles={customStyles}
                    isSearchable
                    className="ptrm-select-container"
                  />
                </div>
              </div>
              <div className="ptrm-form-row">
                <div className="ptrm-form-group ptrm-full-width">
                  <label htmlFor="capacity" className='ptrm-label'>Nombre de lits</label>
                  <input
                    id="capacity"
                    name="capacity"
                    type="number"
                    min="1"
                    value={roomData.capacity}
                    onChange={handleRoomChange}
                    required
                    className="ptrm-input"
                  />
                </div>
              </div>
              <div className="ptrm-form-row">
                <div className="ptrm-form-group ptrm-full-width">
                  <label htmlFor="pricePerDay" className='ptrm-label'>Prix par jour</label>
                  <input
                    id="pricePerDay"
                    name="pricePerDay"
                    type="number"
                    min="1"
                    value={roomData.pricePerDay}
                    onChange={handleRoomChange}
                    required
                    className="ptrm-input"
                  />
                </div>
              </div>
              <div className="ptrm-form-actions">
                <button type="submit" className="ptrm-btn-save">
                  Ajouter
                </button>
                <button
                  type="button"
                  className="ptrm-btn-cancel"
                  onClick={() => setShowRoomModal(false)}
                >
                  Annuler
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* Modal: Nouveau Lit */}
      {showBedModal && (
        <div className="ptrm-modal-overlay">
          <div className="ptrm-modal-content">
            <h2 className="ptrm-modal-header">Ajouter un lit à la chambre {selectedRoomForBeds?.roomNumber}</h2>
            <form onSubmit={handleBedSubmit} className="ptrm-form">
              <div className="ptrm-form-row">
                <div className="ptrm-form-group ptrm-full-width">
                  <label htmlFor="bedNumber" className='ptrm-label'>Numéro du lit</label>
                  <input
                    id="bedNumber"
                    name="bedNumber"
                    type="text"
                    value={bedData.bedNumber}
                    onChange={handleBedChange}
                    required
                    className="ptrm-input"
                  />
                </div>
              </div>
              <div className="ptrm-form-row">
                <div className="ptrm-form-group ptrm-full-width">
                  <label htmlFor="description" className='ptrm-label'>Description (optionnel)</label>
                  <input
                    id="description"
                    name="description"
                    type="text"
                    value={bedData.description}
                    onChange={handleBedChange}
                    className="ptrm-input"
                  />
                </div>
              </div>
              <div className="ptrm-form-actions">
                <button type="submit" className="ptrm-btn-save">
                  Ajouter
                </button>
                <button
                  type="button"
                  className="ptrm-btn-cancel"
                  onClick={() => setShowBedModal(false)}
                >
                  Annuler
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {onBack && <button className="ptrm-btn-back" onClick={onBack}>Retour</button>}
    </div>
  );
}
export default AdmissionPatientComponent;